import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Logo and Description */}
        <div className={styles.footerAbout}>
          <h4 className={styles.footerLogo}>Gradify</h4>
          <p>
            Empowering students and professionals to gain real-world experience through high-quality
            internship programs. Join us and shape your future.
          </p>
        </div>

        {/* Quick Links */}
        <div className={styles.footerLinks}>
          <h4>Quick Links</h4>
          <ul>
            <li>
              <Link to="/" className={styles.footerLink}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/programs" className={styles.footerLink}>
                Programs
              </Link>
            </li>
            <li>
              <Link to="/about" className={styles.footerLink}>
                About
              </Link>
            </li>
            <li>
              <Link to="/contact" className={styles.footerLink}>
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className={styles.footerContact}>
          <h4>Contact Us</h4>
          <p>Email: info@stehawk.com</p>

          <a href="tel:+917989329299">Phone: +91 798-932-9299</a>
          <div className={styles.socialIcons}>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className={styles.footerCopyright}>
        <p>&copy; {new Date().getFullYear()} Gradify. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
